var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', [_vm._v("OS-Simplificada")]), _c('b-card', [_c('DadosGerais'), _c('Servicos'), _c('PagamentosTab'), _c('ObservacoesTab')], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_c('div', {
    staticClass: "form mb-5"
  }, [_c('button', {
    ref: "submit_nova_os",
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": _vm.salvarOrdemSimplificada
    }
  }, [_vm._v(" Salvar ")]), _c('button', {
    ref: "submit_previa_nfe",
    staticClass: "btn btn-clean font-weight-bold",
    on: {
      "click": function click($event) {
        return _vm.confirmCancel('simplificada');
      }
    }
  }, [_vm._v(" Cancelar ")])])])])])])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };